import { fillObject } from 'utils'

import { declarationInputs } from './DeclarationsHmda/constants'

export enum BorrowerSeperator {
  BORROWER = 'borrower',
  CO_BORROWER = 'coBorrower',
  CO_BORROWER2 = 'coBorrower2',
  CO_BORROWER3 = 'coBorrower3',
  CO_BORROWER4 = 'coBorrower4',
  CO_BORROWER5 = 'coBorrower5',
  CO_BORROWER6 = 'coBorrower6',
  CO_BORROWER7 = 'coBorrower7',
}

export const BorrowerSeparatorList = Object.values(BorrowerSeperator)

export const CoBorrowers: Array<string> = BorrowerSeparatorList.filter((v) => v !== BorrowerSeperator.BORROWER)

export const BorrowerLabel: Record<string, string> = fillObject(
  BorrowerSeparatorList,
  (borrowerSep: any) => `Borrower ${BorrowerSeparatorList.indexOf(borrowerSep) + 1}`,
)

export const excelKeys = [
  'borrower',
  '',
  'declaration',
  '',
  'assets',
  '',
  'liabilities',
  '',
  'tracks',
  'rentalEstates',
  '',
]
export const tableLabels: Record<string, string> = {
  borrower: 'Borrower',
  declaration: 'Declaration & HMDA',
  assets: 'Assets',
  liabilities: 'Liabilities',
  tracks: 'Track Record',
  rentalEstates: 'Real Estate Owned',
}
export const tableHeader: Record<string, string[]> = {
  borrower: [
    'First Name',
    'Middle Name',
    'Last Name',
    'Email',
    'Phone',
    'SSN',
    'DOB',
    'Present Address',
    'Mailing Address',
    'Has Entity Title',
    'Entity Name',
    'Entity Address',
    'State of Entity',
    'Entity Tax ID',
    'Citizenship',
    'Borrower Type',
    'Borrower Position',
    'Ownership Percentage',
    'Title Vesting',
    'Ownership',
    'Owned Rented Years',
    'Former Address',
    'Former Ownership',
    'Former Owned Rented Years',
    'Marital Status',
  ],
  declaration: [
    ...Object.values(declarationInputs).map((input: any) => input.title),
    'Borrower',
    'Information Provided Via',
    'Sex',
    'Sex Completed by',
    'Ethnicity',
    'Ethnicity Completed by',
    'Race',
    'Race Completed by',
  ],
  assets: ['Account Type', 'Institution', 'Account Number', 'Account Balance'],
  liabilities: [
    'Liability',
    'Borrower',
    'Account Type',
    'Attn',
    'Address',
    'Account No',
    'Payments Left',
    'Unpaid Balance',
    'Monthly Payment',
    'To Be Paid Off',
    'Resubordinated',
    'Omitted',
    'Listed on Credit Report',
  ],
  tracks: [
    'Property Address',
    'Property Type',
    'Purchase Date',
    'Purchase Price',
    'Renovation Budget',
    'As Rental',
    'Sales Date',
    'Sales Price',
    'Additional Notes',
  ],
  rentalEstates: [
    'Address',
    'Borrower',
    'Held',
    'Is Subject Property Address?',
    'Current Usage',
    'Intended Usage',
    'Status',
    'Type',
    'No Units',
    'Present Market Value',
    'Gross Rental Income',
    'Vacancy Factor',
    'Mortgage Payments',
    'T&I/HOD Included in Mtg',
    'Taxes, Insurance, HOD',
  ],
}

export const borrowerExcelKeys = [
  'firstName',
  'middleName',
  'lastName',
  'email',
  'phone',
  'ssn',
  'dob',
  'presentAddress',
  'mailingAddress',
  'hasEntityTitle',
  'entityTitle',
  'entityAddress',
  'entityState',
  'entityTaxID',
  'residency',
  'borrowerType',
  'borrowerPosition',
  'ownershipPercentage',
  'titleVesting',
  'ownership',
  'ownedRentedYears',
  'formerAddress',
  'formerOwnership',
  'formerOwnedRentedYears',
  'maritalStatus',
]

export const hmdaExcelKeys = [
  'isBorrower',
  'informationProvidedVia',
  'sex',
  'sexCompletedBy',
  'ethnicity',
  'ethnicityCompletedBy',
  'race',
  'raceCompletedBy',
]

export const declarationExcelKeys = [...Object.keys(declarationInputs), ...hmdaExcelKeys]
